import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { HumanInteractionService } from '../../../../services/human-interaction.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {WfTableComponent} from '../../../../common/table-sort/wf-table.component';
import {Subject} from 'rxjs';
import {CustomValidator} from '../../../../services/custom-validator';
import {CardInfo, InteractionQueue, InteractionQueueColumn} from '../../../../Models/human-interaction/cardInfo';

@Component({
  selector: 'app-queue-columns-preview-modal',
  templateUrl: './queue-columns-preview-modal.component.html',
  styleUrls: ['./queue-columns-preview-modal.component.css']
})
export class QueueColumnsPreviewModalComponent implements OnInit {

  @Input() modalTitle: string;
  error = '';
  objInitialState: any;
  cardInfo: CardInfo;
  queueConfig: InteractionQueue;
  columns;
  rows;

  constructor(
    private humanInteractionService: HumanInteractionService,
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.columns = this.objInitialState;
    this.rows =[];
    this.cardInfo = {
      businessProcessId: 0,
      businessProcessInstanceId: 0,
      businessProcessName: '',
      captionText: '',
      color: '',
      creationDate: new Date(),
      customInteractionQueueConfigId: 0,
      detailsText: '',
      fontColor: '',
      interactionSymbolInfo: '',
      modifiedBy: '',
      stateDisplayName: '',
      stateExecutionOrder: 0,
      stateId: 0,
      stateLifeCycle: 0,
      stateModifyDate: new Date(),
      values: []
    }
    this.queueConfig = {
      orderDirection:0,
      orderByColumn:null,
      columns: this.columns,
      colors: []
    }
  }



  onClickOk() {

    this.bsModalRef.hide();
  }

  onClose() {
    this.bsModalRef.hide();
  }
}
